import { Link } from '@tanstack/react-router';

/**
 * Error page for the terms routes while Payload is unreachable. Legal pages
 * deliberately have no static fallback, so this replaces a possibly outdated
 * copy of the terms rather than an empty page.
 */
export function LegalPagesUnavailable() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <p className="text-note font-medium tracking-widest text-grey-500 uppercase">
        Temporarily unavailable
      </p>
      <h1 className="text-h2 font-semibold">We can’t show our terms right now</h1>
      <p className="max-w-md text-body text-grey-600">
        Something went wrong loading this page. Please try again in a few minutes, or contact
        support@nsave.com if you need a copy of our terms.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-pill bg-red-500 px-6 py-3 text-body-m font-medium text-white shadow-red-btn transition-colors hover:bg-red-700">
          Try again
        </button>
        <Link to="/" className="text-body-m font-medium text-grey-900 hover:text-black">
          Back to home
        </Link>
      </div>
    </main>
  );
}
